const isHtmlUnformatted = (html) => {
  const trimmed = html.trim();
  if (!trimmed) return false;

  const hasNoNewlines = !trimmed.includes('\n');
  const lines = trimmed.split('\n');
  const hasLongLine = lines.some(line => line.length > 300);

  return hasNoNewlines || hasLongLine;
};

const formatHtml = (html) => {
  if (!html || !html.trim()) return html;

  const tokens = html.match(/<[^>]+>|[^<]+/g) || [];
  let depth = 0;
  const lines = [];
  let inScriptOrStyle = false;

  for (let i = 0; i < tokens.length; i++) {
    const token = tokens[i];

    if (token.trim() === '') continue;

    if (token.startsWith('<')) {
      const tagName = token.match(/<\/?([a-zA-Z][a-zA-Z0-9]*)/)?.[1]?.toLowerCase();

      if (tagName === 'script' || tagName === 'style') {
        inScriptOrStyle = !token.startsWith('</');
      }

      if (inScriptOrStyle && tagName !== 'script' && tagName !== 'style') {
        lines[lines.length - 1] = lines[lines.length - 1] + token;
        continue;
      }

      const isClosingTag = token.startsWith('</');
      const isSelfClosing = token.endsWith('/>') ||
        /^(<br>|<img|<input|<hr|<meta|<link)/i.test(token);
      const isComment = token.startsWith('<!--');

      if (isClosingTag) {
        depth = Math.max(0, depth - 1);
      }

      const indent = '  '.repeat(depth);
      lines.push(indent + token);

      if (!isClosingTag && !isSelfClosing && !isComment) {
        depth++;
      }
    } else if (inScriptOrStyle) {
      const trimmed = token.trim();
      if (trimmed) {
        lines[lines.length - 1] = lines[lines.length - 1] + trimmed;
      }
    } else {
      const trimmed = token.trim();
      if (trimmed) {
        const indent = '  '.repeat(depth);
        lines.push(indent + trimmed);
      }
    }
  }

  return lines.join('\n');
};

export { isHtmlUnformatted, formatHtml };
